import React from "react"
import { Skeleton, Text } from "@chakra-ui/react"

export type ExoskeletonProps = {
  isLoading?: boolean
  children?: React.ReactNode
}

const defaultDummyChildren = <Text>Loading...</Text>

export default function Exoskeleton({ isLoading, children, ...otherProps }: ExoskeletonProps): JSX.Element {
  let stuffToRender = children

  if (isLoading && !children) {
    stuffToRender = defaultDummyChildren
  }

  return (
    <Skeleton {...otherProps} isLoaded={!isLoading}>
      {stuffToRender}
    </Skeleton>
  )
}
